import React, { Fragment } from "react";
import { useIntl } from 'react-intl';

import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import TextSection from "@components/aboutUsPage/TextSection/textSection";

const heroImage = {
  url: `${process.env.CDN_URL}/images/about-us.jpg`,
  alt: 'About Us Hero Image'
}

const AboutUsTemplate = ({ pageContext: { locale } }) => {
  const intl = useIntl();

  const heroHeading = intl.formatMessage({ id: 'About us' });
  const title = intl.formatMessage({ id: 'What is Uniplaces?' });
  const text = intl.formatMessage({ id: 'About us text' });
  const subtitle = intl.formatMessage({ id: 'This is our way of turning an old-fashioned market on its head. It’s our way of changing the world.' });

  return (
    <Fragment>
      <SEO
        titleKey="About us"
        descriptionKey="Rent your accommodation with Uniplaces, the safe and easy housing platform to find and book rooms, apartments, flats and residences."
        imageUrl={heroImage.url}
        lang={locale}
      />
      <HeroSection
        heroHeading={heroHeading}
        heroImage={heroImage}
      />
      <UniplacesFullContainer>
          <TextSection title={title} text={text} subtitle={subtitle} />
          <Controls />
      </UniplacesFullContainer>
    </Fragment>
  );
};

export default AboutUsTemplate;
